export const withTimeout = (promise, ms, createError) =>
  new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(createError()), ms);
    Promise.resolve(promise).then(
      (value) => { clearTimeout(timer); resolve(value); },
      (error) => { clearTimeout(timer); reject(error); },
    );
  });
